import React,{createContext,useContext,useEffect,useState,useCallback} from 'react';
import {api} from './api';
import {User,Business} from '../types';
interface AuthState {user:User|null;business:Business|null;loading:boolean;refresh:()=>Promise<void>;logout:()=>Promise<void>}
const AuthContext=createContext<AuthState>({user:null,business:null,loading:true,refresh:async()=>{},logout:async()=>{}});
export const AuthProvider=({children}:{children:React.ReactNode})=>{
 const[user,setUser]=useState<User|null>(null),[business,setBusiness]=useState<Business|null>(null),[loading,setLoading]=useState(true);
 const refresh=useCallback(async()=>{try{const{data}=await api.get('/auth/me');setUser(data.user);setBusiness(data.business);}catch{setUser(null);setBusiness(null);}finally{setLoading(false);}},[]);
 useEffect(()=>{
   // If returning from Google OAuth callback, AuthCallback exchanges the session_id and calls refresh() itself.
   if(typeof window!=='undefined'&&window.location.hash&&window.location.hash.includes('session_id=')){setLoading(false);return;}
   void refresh();
 },[refresh]);
 const logout=async()=>{await api.post('/auth/logout');setUser(null);setBusiness(null);};
 return <AuthContext.Provider value={{user,business,loading,refresh,logout}}>{children}</AuthContext.Provider>;
};
export const useAuth=()=>useContext(AuthContext);
